import React from 'react';
import TextToHtml from "@/components/text-to-html";

function LmsTextStepSection({levelDetail}) {
    return (
        <div className={'p-2 m-2'}>
            <TextToHtml>{levelDetail?.desc2}</TextToHtml>
        </div>
    );
}

export default LmsTextStepSection;